@if(spinnerType == 'fullPage'){
<nz-spin nzSimple nzTip="loading" nzSize="large" class="loader">
</nz-spin>
}
@else {
<div class="loader-wrapper">
    <nz-spin nzSimple nzTip="loading" nzSize="large">
    </nz-spin>
</div>
}